import { useAuth } from "@/lib/auth";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import Nav from "@/components/Nav";
import Booking from "@/pages/Booking";

export default function MonPlanning() {
  const { user, loading } = useAuth();
  const nav = useNavigate();

  useEffect(() => {
    // Redirect admins to dashboard
    if (!loading && user && user.role === "admin") {
      nav("/admin");
    }
    // Redirect non-authenticated users to login
    if (!loading && !user) {
      nav("/login");
    }
  }, [user, loading, nav]);

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-[#F9F9F6]">
        <div className="text-center">
          <div className="mb-4 h-12 w-12 animate-spin rounded-full border-4 border-stone-200 border-t-stone-900 mx-auto"></div>
          <p className="text-sm text-stone-600">Chargement...</p>
        </div>
      </div>
    );
  }

  if (!user || user.role === "admin") {
    return null;
  }

  return (
    <div className="min-h-screen bg-[#F9F9F6]">
      <Nav />
      <div className="mx-auto max-w-7xl px-6 py-8 lg:px-12">
        <div className="mb-8 text-center">
          <h1 className="font-display text-4xl font-light text-stone-900">
            Mon Planning
          </h1>
          <p className="mt-2 text-sm text-stone-600">
            Bienvenue {user.name} · {user.sessions_per_week} séance(s)/semaine
          </p>
        </div>
        
        {/* Booking component without the nav */}
        <Booking hideNav={true} />
      </div>
    </div>
  );
}
